import { ServicePageHeader, ServicePageCTA, SubServiceCard } from "@/components/ServicePageBits";

const INDUSTRIES = ["Oil & Gas", "Refining", "Petrochemicals", "Chemicals", "Pharmaceuticals", "Power", "Water Treatment", "Paper & Pulp", "Steel"];

const SUBSERVICES = [
  {
    title: "Piping",
    image: "https://www.thantrick.com/wp-content/uploads/2025/04/34b658d354e4833dbe241d5e1732ead4-1024x768.jpg",
    body: [
      "At ZeroLabs, we specialize in innovative process design, engineering and simulation services across a diverse range of industries — Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Water Treatment, and Paper & Pulp.",
      "From Front-End Engineering Design (FEED) to detailed engineering, we offer end-to-end solutions that ensure efficiency and quality throughout every phase of your project.",
      "Our experienced team leverages cutting-edge engineering software to deliver precision-driven results tailored to your specific needs.",
    ],
    tools: ["AVEVA E3D", "AVEVA PDMS", "Hexagon SmartPlant 3D", "Autodesk Plant 3D", "Bentley OpenPlant", "Vertex", "Revit", "EZ-ISO"],
    internalHref: "/piping",
    readMoreHref: "https://thantrick.org/piping/",
  },
  {
    title: "Civil & Structural",
    image: "https://www.thantrick.com/wp-content/uploads/2025/04/civil-1024x576.jpg",
    body: [
      "ZeroLabs Digitals' Civil and Structural team brings extensive expertise in detailed design and engineering for a variety of industries — Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Power, Water Treatment, and Paper & Pulp.",
      "We provide comprehensive solutions that meet the highest industry standards, ensuring safety, efficiency, and precision in every project.",
    ],
    tools: ["Autodesk Revit Structure", "AVEVA", "Hexagon", "Tekla Structures", "STAAD.Pro"],
    internalHref: "/civil-structural",
    readMoreHref: "https://thantrick.org/civil-structural/",
  },
  {
    title: "Electrical & Instrumentation",
    image: "https://www.thantrick.com/wp-content/uploads/2025/04/electrical.jpg",
    body: [
      "ZeroLabs Digitals' Electrical & Instrumentation (E&I) team offers extensive experience in design and engineering across Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Power, Water Treatment and Paper & Pulp.",
      "We provide tailored E&I solutions that ensure optimal performance and compliance with industry standards.",
    ],
    tools: ["Autodesk", "AVEVA", "Bentley", "ETAP", "SmartPlant Instrumentation"],
    internalHref: "/electrical-instrumentation",
    readMoreHref: "https://thantrick.org/electrical-instrumentation-2/",
  },
  {
    title: "Mechanical",
    image: "https://www.thantrick.com/wp-content/uploads/2025/04/Mechanical-1024x585.webp",
    body: [
      "ZeroLabs Digitals' Mechanical team brings extensive expertise in the design and engineering of Static and Rotating equipment across Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Power, Water Treatment, Paper & Pulp, Steel and more.",
      "We deliver high-quality, tailored mechanical solutions that ensure efficiency, safety and reliability for every project.",
    ],
    tools: ["Autodesk Inventor", "PV Elite", "ANSYS", "Compress"],
    internalHref: "/mechanical",
    readMoreHref: "https://thantrick.org/mechanical-2/",
  },
  {
    title: "Material (Certification Verification)",
    image: "https://www.thantrick.com/wp-content/uploads/2025/04/MTC-1024x1024.jpg",
    body: [
      "ZeroLabs Digitals team has experience inspecting Material Test Certificates (MTC) from a wide range of vendor documents, performing inspection and approval for client-required components like Pipe Fittings, Valves, Civil profiles, Equipment and Electrical components.",
      "We verify MTCs to EN 10204 standard — 2.1 (Declaration of compliance), 2.2 (Test reports — basic compliance & non-specific test results), 3.1 (Inspection certificate issued by manufacturer's authorized inspector with actual test results), and 3.2 (Inspection certificates verified by both manufacturer and an independent third-party inspector).",
    ],
    tools: ["EN 10204", "ASME", "ASTM", "API"],
    internalHref: "/materials",
    readMoreHref: "https://thantrick.org/materials/",
  },
];

export default function PlantEngineering() {
  return (
    <div data-testid="page-plant-engineering">
      <ServicePageHeader
        eyebrow="Plant engineering"
        title="Precision engineering for industrial plants — at world-class standards."
        breadcrumb="Home / Services / Plant Engineering"
        lead={
          "From FEED through detailed engineering, we deliver multidisciplinary plant design powered by industry-leading toolchains. Five specialised disciplines — one accountable team."
        }
      />

      {/* Industries strip */}
      <section className="py-8 border-y border-white/5 bg-[#0E0B17]/60">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.25em] text-[#64748B] mb-3">Industries we serve</div>
          <div className="flex flex-wrap gap-2">
            {INDUSTRIES.map((i) => (
              <span key={i} className="px-3 py-1.5 rounded-full text-sm border border-white/10 text-[#E2E8F0] bg-white/[0.03]">{i}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-20">
          {SUBSERVICES.map((s, i) => (
            <SubServiceCard key={s.title} {...s} reverse={i % 2 === 1} />
          ))}
        </div>
      </section>

      <ServicePageCTA />
    </div>
  );
}
